import { Component, OnInit, Input, HostListener, DoCheck, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TableHandler, Col, Row } from '../../../../../../../classes';
import { FormGroup, NgModel, Validators } from '@angular/forms';

@Component({
  selector: '[header-cell]',
  templateUrl: './header-cell.component.html',
  styleUrls: ['./header-cell.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class HeaderCellComponent implements OnInit, DoCheck {
  @Input() table:TableHandler;
  @Input() questionFormGroup:FormGroup;
  @Input() col:Col;
  @Input() row:Row;
  @ViewChild('text') text:NgModel
   
  get value () {
    if (this.row.priority === 0) return this.col.text;
    else if (this.col.priority === 0) return this.row.text;
  }
  set value (v:string) {
    if (this.row.priority === 0) this.col.text = v;
    else if (this.col.priority === 0) this.row.text = v;
  }
  formControlKey:string;
  constructor(
    private elementRef:ElementRef,
    private renderer:Renderer2,
  ) { }

  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'position-relative');
    this.renderer.addClass(this.elementRef.nativeElement, 'p-0');
    if (this.col.priority === 0 || this.row.priority === 0) {
      if (this.col.priority === 0) {
        this.renderer.addClass(this.elementRef.nativeElement, 'left-header');
      }  
      else if (this.row.priority === 0) {
        this.renderer.addClass(this.elementRef.nativeElement, 'top-header');
      }  
      if (this.text && !(this.col.priority === 0 && this.row.priority === 0)) {
        this.text.control.setValidators([Validators.required]);
        this.text.control.setValue(this.value);
        this.formControlKey = `${this.col.id}-${this.row.id}`;
        this.questionFormGroup.setControl(this.formControlKey, this.text.control);
        this.text.control.statusChanges.subscribe(()=>this.refreshInvalidStatus());

      }  
    }
  }
  refreshInvalidStatus () {
    if (this.text.control.invalid) this.renderer.addClass(this.elementRef.nativeElement, 'invalid');
    else this.renderer.removeClass(this.elementRef.nativeElement, 'invalid');
  }
  ngOnDestroy () {
    if (this.formControlKey) this.questionFormGroup.removeControl(this.formControlKey);
  }
  ngDoCheck () {
    if (
      (this.table.focus.colId === this.col.id && this.table.focus.rowId === undefined) 
      || (this.table.focus.colId === undefined && this.table.focus.rowId === this.row.id) 
      || (this.table.focus.colId === this.col.id && this.table.focus.rowId === this.row.id)
    ) {
      this.renderer.addClass(this.elementRef.nativeElement, 'focus');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'focus');
    }
  }
  @HostListener('click', []) toggleFocus (bool:boolean = undefined) {
    this.table.toggleFocus(this.col.id, this.row.id, bool);
  }

}
